import { render, staticRenderFns } from "./select-goods.vue?vue&type=template&id=1de4ad5a&scoped=true"
import script from "./select-goods.vue?vue&type=script&lang=js"
export * from "./select-goods.vue?vue&type=script&lang=js"
import style0 from "./select-goods.vue?vue&type=style&index=0&id=1de4ad5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de4ad5a",
  null
  
)

export default component.exports